<script lang="ts">
  import { community } from "app/stores/community";
  import DocNavButton from "./DocNavButton.svelte";
  import type { WritableDocument } from "app/models/documents";
  import { docURL } from "app/utils/urls";
  import { slugify } from "app/utils/strings";

  export let currentDocument: WritableDocument;

  $: nextDoc = currentDocument.getNextDoc();
  $: previousDoc = currentDocument.getPreviousDoc();
</script>

<div class="flex justify-between">
  <div>
    {#if previousDoc}
      <DocNavButton
        name={previousDoc.title}
        isNext={false}
        link={docURL({
          docUuid: previousDoc.uuid,
          docSlug: slugify(previousDoc.title),
          communitySlug: $community.slug,
        })}
      />
    {/if}
  </div>

  <div>
    {#if nextDoc}
      <DocNavButton
        name={nextDoc.title}
        isNext
        link={docURL({
          docUuid: nextDoc.uuid,
          docSlug: slugify(nextDoc.title),
          communitySlug: $community.slug,
        })}
      />
    {/if}
  </div>
</div>
